import { render, staticRenderFns } from "./page-favourites.vue?vue&type=template&id=b04cce00&scoped=true"
import script from "./page-favourites.vue?vue&type=script&lang=js"
export * from "./page-favourites.vue?vue&type=script&lang=js"
import style0 from "./page-favourites.vue?vue&type=style&index=0&id=b04cce00&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b04cce00",
  null
  
)

export default component.exports